import Rohr from './3rd-lib/rohr'
import knbUse from './knb/knb-use'
import Agent from './agent'
import { I_MP_OAUTH, MpOauth } from './mp-oauth'

export function getFingerprint(apiUrl: string): Promise<string> {
  // 获取fingerprint
  return new Promise((resolve) => {
    if (Agent.native) {
      knbUse('getFingerprint', {
        success: (data: { fingerprint: string }) => resolve(data.fingerprint),
      })
    } else if (apiUrl) {
      // i版fingerprint https://km.sankuai.com/page/31783846
      Rohr(apiUrl).then((_token) => {
        resolve(_token)
      })
    } else {
      resolve('')
    }
  })
}

const orderSourceType: Record<string, number> = {
  phx_android: 1,
  phx_ios: 2,
  i: 6, // 美团民宿网页版
  meituan: 3,
  dianping: 4,
  dianping_nova: 4,
  phoenix_wxapp: 5,
  dianping_wxapp: 8,
  group_wxapp: 9,
  phoenix_swan: 12,
  phoenix_xhsapp: 13,
  hotel_wxapp: 14,
}

export function getOrderSouceType() {
  if (Agent.phx && Agent.android) return orderSourceType['phx_android']
  if (Agent.phx && Agent.iphone) return orderSourceType['phx_ios']
  return orderSourceType[Agent.appnm] ? orderSourceType[Agent.appnm] : orderSourceType['i']
}

export async function getMpRiskControlInfo(
  apiUrl: string,
  mpoauth: MpOauth,
): Promise<{
  fingerprint: string
  mpUserInfo: I_MP_OAUTH['mpUserInfo']
}> {
  const fingerprint = await getFingerprint(apiUrl)
  return {
    fingerprint,
    mpUserInfo: mpoauth.mpUserInfo,
  }
}

export async function getRiskControlInfo(apiUrl: string, mpoauth: MpOauth) {
  const fingerprint = await getFingerprint(apiUrl)
  if (Agent.anyminiprogram || Agent.weixin) {
    return {
      fingerprint,
      openid: mpoauth.openid,
      wxAccountId: mpoauth.mpact.accountId,
    }
  }
  return {
    fingerprint,
  }
}

export async function getCouponRiskControlInfo(apiUrl: string, mpoauth: MpOauth) {
  const fingerprint = await getFingerprint(apiUrl)
  if (Agent.weixin) {
    return {
      fingerprint,
      url: window.location.href, // 领券待后端删除
      wxRiskLevel: {
        openid: mpoauth.openid,
      },
    }
  }
  return {
    fingerprint,
    url: window.location.href, // 领券待后端删除
  }
}
